module.exports = __webpack_public_path__ + "static/media/logo_white.bebd2a97.svg";